// extracted by mini-css-extract-plugin
export default {"form":"InstanceManagementDialog_form__V922Z","secret":"InstanceManagementDialog_secret__8QPSi"};